import React, { useEffect, useState } from 'react';
import {
  MailchimpSignUpFormProps,
  FormData,
} from './mailchimp-sign-up-form.types';
import { MailchimpSignUpFormContainer } from './mailchimp-sign-up-form.styles';

const MailchimpSignUpForm: React.FC<MailchimpSignUpFormProps> = ({
  className,
}) => {
  const [formData, setFormData] = useState<FormData>({});
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const isCheckbox = (target: EventTarget): target is HTMLInputElement =>
      (target as HTMLInputElement).type === 'checkbox';

    setFormData({
      ...formData,
      [name]: isCheckbox(e.target) ? e.target.checked : value,
    });
  };

  useEffect(() => {
    const successElement = document.getElementById('mce-success-response');

    if (!successElement) return;

    const checkForSuccess = () => {
      if (successElement.style.display !== 'none' && successElement.innerText) {
        setFormData({});
      }
    };

    const observer = new MutationObserver(checkForSuccess);
    const config = { childList: true, subtree: true };
    observer.observe(successElement, config);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const form = document.getElementById(
      'mc-embedded-subscribe-form'
    ) as HTMLFormElement | null;

    if (!form) return;

    const validateNewsletterSelection = (e: SubmitEvent) => {
      const periodicNewsletter = document.getElementById(
        'mc-group[3652]-3652-0'
      ) as HTMLInputElement | null;

      const northAmericaNewsletter = document.getElementById(
        'mce-group[3667]-3667-0'
      ) as HTMLInputElement | null;

      const hasNewsletterSelected =
        periodicNewsletter?.checked || northAmericaNewsletter?.checked;

      const errorElement = document.getElementById('mce-error-response');

      if (!hasNewsletterSelected) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (errorElement) {
          errorElement.style.display = 'block';
          errorElement.innerHTML =
            '<p class="newsletter-error">Please select at least one newsletter.</p>';
        }

        return;
      }

      if (errorElement) {
        errorElement.style.display = 'none';
        errorElement.innerHTML = '';
      }
    };

    form.addEventListener('submit', validateNewsletterSelection, true);

    return () => {
      form.removeEventListener('submit', validateNewsletterSelection, true);
    };
  }, []);

  return (
    <MailchimpSignUpFormContainer>
      <div id="mc_embed_shell" className={className}>
        <div id="mc_embed_signup">
          <form
            action="https://ellenmacarthurfoundation.us7.list-manage.com/subscribe/post?u=bbd27f61161a220e88d7186d4&amp;id=f507e40a10&amp;f_id=009ea2e0f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="validate"
            target="_blank"
          >
            <div id="mc_embed_signup_scroll">
              <div className="indicates-required">
                <span className="asterisk">*</span> indicates required
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-EMAIL">
                  Business Email <span className="asterisk">*</span>
                </label>
                <input
                  type="email"
                  name="EMAIL"
                  className="required email"
                  id="mce-EMAIL"
                  required
                  value={(formData.EMAIL as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-FNAME">First Name* </label>
                <input
                  type="text"
                  name="FNAME"
                  className="required text"
                  id="mce-FNAME"
                  required
                  value={(formData.FNAME as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-LNAME">Last Name* </label>
                <input
                  type="text"
                  name="LNAME"
                  className="required text"
                  id="mce-LNAME"
                  required
                  value={(formData.LNAME as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-ROLE">Function / Department* </label>
                <select
                  name="ROLE"
                  className=""
                  id="mce-ROLE"
                  value={(formData.ROLE as string) || ''}
                  onChange={handleChange}
                  onBlur={handleChange}
                >
                  <option value=""></option>
                  <option value="Accounting">Accounting</option>
                  <option value="Communications">Communications</option>
                  <option value="Design">Design</option>
                  <option value="Entrepreneur">Entrepreneur</option>
                  <option value="Estate Management">Estate Management</option>
                  <option value="Finance">Finance</option>
                  <option value="Human Resources (HR)">
                    Human Resources (HR)
                  </option>
                  <option value="Information Technology (IT)">
                    Information Technology (IT)
                  </option>
                  <option value="Learning and Development">
                    Learning and Development
                  </option>
                  <option value="Policy-Maker">Policy-Maker</option>
                  <option value="Procurement">Procurement</option>
                  <option value="Product Development">
                    Product Development
                  </option>
                  <option value="Production">Production</option>
                  <option value="Public Affairs">Public Affairs</option>
                  <option value="Research and Development, Innovation">
                    Research and Development (R&amp;D), Innovation
                  </option>
                  <option value="Sales &amp; Marketing">
                    Sales &amp; Marketing
                  </option>
                  <option value="Strategy, Administrative and Management">
                    Strategy, Administrative and Management
                  </option>
                  <option value="Supply Chain Management">
                    Supply Chain Management
                  </option>
                  <option value="Sustainability and Circular Economy">
                    Sustainability and Circular Economy
                  </option>
                  <option value="University">University</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-LEVEL">Seniority* </label>
                <select
                  name="LEVEL"
                  className=""
                  id="mce-LEVEL"
                  value={(formData.LEVEL as string) || ''}
                  onChange={handleChange}
                  onBlur={handleChange}
                >
                  <option value=""></option>
                  <option value="Executive/Senior Leader">
                    Executive/Senior Leader
                  </option>
                  <option value="Director">Director</option>
                  <option value="Mid-Senior">Mid-Senior</option>
                  <option value="Associate">Associate</option>
                  <option value="Entry">Entry</option>
                </select>
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-JOBTITLE">
                  Job Title <span className="asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="JOBTITLE"
                  className="required text"
                  id="mce-JOBTITLE"
                  required
                  value={(formData.JOBTITLE as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-ORGNAME">
                  Organisation Name <span className="asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="ORGNAME"
                  className="required text"
                  id="mce-ORGNAME"
                  required
                  value={(formData.ORGNAME as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group input-group">
                <label htmlFor="mc-group[3652]">
                  For circular economy news and updates from across the
                  Foundation{' '}
                </label>
                <ul className="checkbox">
                  <li>
                    <label htmlFor="mc-group[3652]-3652-0">
                      Periodic Newsletter
                      <input
                        type="checkbox"
                        name="group[3652][1024]"
                        id="mc-group[3652]-3652-0"
                        value="1024"
                        checked={!!formData['group[3652][1024]']}
                        onChange={handleChange}
                      />
                    </label>
                  </li>
                </ul>
              </div>
              <div className="mc-field-group input-group">
                <label htmlFor="mc-group[3667]">
                  For circular economy news and updates in North America{' '}
                </label>
                <ul className="checkbox">
                  <li>
                    <input
                      type="checkbox"
                      name="group[3667][4096]"
                      id="mce-group[3667]-3667-0"
                      checked={!!formData['group[3667][4096]']}
                      value="4096"
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3667]-3667-0">
                      North America Newsletter
                    </label>
                  </li>
                </ul>
              </div>
              <div id="mce-responses" className="clear">
                <div
                  className="response"
                  id="mce-error-response"
                  style={{ display: 'none' }}
                ></div>
                <div
                  className="response"
                  id="mce-success-response"
                  style={{ display: 'none' }}
                ></div>
              </div>
              <div
                aria-hidden="true"
                style={{ position: 'absolute', left: '-5000px' }}
              >
                <input
                  type="text"
                  name="b_bbd27f61161a220e88d7186d4_f507e40a10"
                  tabIndex={-1}
                  value={
                    (formData.b_bbd27f61161a220e88d7186d4_f507e40a10 as string) ||
                    ''
                  }
                  onChange={handleChange}
                />
              </div>
              <div className="clear">
                <input
                  type="submit"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  className="button"
                  value="Subscribe"
                  gtm-id="newsletter_subscribe"
                />
              </div>
              <div>
                <p className="t-and-c">
                  By clicking subscribe I agree that the Ellen MacArthur
                  Foundation may add me to its email contact list to receive
                  copies of its newsletter and other updates on its work. You
                  can unsubscribe at any time by clicking the link in the footer
                  of our emails.
                </p>
                <p className="t-and-c">
                  The Ellen MacArthur Foundation will process the personal data
                  you have provided in accordance with{' '}
                  <a href="/policies">
                    Ellen MacArthur Foundation's privacy policy
                  </a>
                  . The privacy policy contains more information about how your
                  personal data is used, including how your personal data is
                  shared and your legal rights in respect of your personal data.
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </MailchimpSignUpFormContainer>
  );
};

export default MailchimpSignUpForm;
